module.exports = __webpack_public_path__ + "static/img/titlepic_ru.0ece021.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/titlepic_ru.png
// module id = hhnT
// module chunks = 1